module.exports = "/_next/static/images/b541fcc971f06efa4558bba200100a1a-nubanker-bizarch@0.5x.jpg";